import { Box, Button, Dialog, DialogTitle, Typography } from "@mui/material";
import React, { useState } from "react";
import COLORS from "../../../constants/Colors";
import { useDashLayoutCtx } from "./DashLayoutCtxProvider";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { getTransDataFromLs, getUserDataFromLs } from "../../../funcs/LSFuncs";

const TabTile = ({ tabItem }) => {
  const { selTab, setselTab, navToScreen } = useDashLayoutCtx();
  const selected = tabItem.id === selTab?.id;
  return (
    <Box
      onClick={() => {
        navToScreen(tabItem.id);
        setselTab(tabItem);
      }}
      sx={{
        background: selected ? "#F2F2F2" : null,
        padding: "0.6rem",
        borderRadius: "6px",
        display: "flex",
        flexDirection: "row",
        cursor: "pointer",
      }}
    >
      <Box sx={{ opacity: selected ? "0.8" : "0.4", mr: "5px" }}>
        {tabItem.icon}
      </Box>
      <Typography
        fontSize={"1rem"}
        fontWeight={selected ? 600 : 500}
        sx={{ opacity: selected ? 1 : "0.8" }}
      >
        {tabItem.label}
      </Typography>
    </Box>
  );
};

const AvatarElement = () => {
  const { navToScreen } = useDashLayoutCtx();
  return (
    <Box
      sx={{ display: "flex", flexDirection: "row", cursor: "pointer" }}
      onClick={() => navToScreen(4)}
    >
      <Box
        sx={{
          height: "40px",
          width: "40px",
          background: COLORS.PRIMARY_GRAD,
          borderRadius: "8px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography fontSize={"1.2rem"} fontWeight={700} color="white">
          {getUserDataFromLs()?.subject?.name?.display[0] || "U"}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          ml: "10px",
          mt: "-2px",
        }}
      >
        <Typography fontSize={"1rem"} fontWeight={500}>
          {getUserDataFromLs()?.subject?.name?.display || "User"}
        </Typography>
        <Typography
          fontSize={"0.8rem"}
          fontWeight={500}
          sx={{ opacity: "0.5" }}
        >
          {getTransDataFromLs()?.name || ""}
        </Typography>
      </Box>
    </Box>
  );
};

const LogoutDialog = ({ onCloseFunc, open }) => {
  const { logOutFromDashboard } = useDashLayoutCtx();
  return (
    <Dialog open={open} onClose={onCloseFunc}>
      <DialogTitle
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          paddingBottom: "0px !important",
        }}
      >
        <ExitToAppIcon
          sx={{
            mr: "5px",
          }}
        />
        Log out?
      </DialogTitle>
      <Box
        sx={{
          width: "300px",
          padding: "24px",
        }}
      >
        <Typography
          fontSize={"1rem"}
          fontWeight={400}
          sx={{
            opacity: "0.7",
          }}
        >
          Are you sure you want to logout?
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
            mt: "20px",
          }}
        >
          <Button
            sx={{
              fontFamily: "inherit",
            }}
            onClick={onCloseFunc}
          >
            CANCEL
          </Button>
          <Button
            sx={{
              fontFamily: "inherit",
            }}
            onClick={logOutFromDashboard}
          >
            OK
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

function DashboardNav() {
  const { dashTabs } = useDashLayoutCtx();
  const [openLogoutDialog, setopenLogoutDialog] = useState(false);
  return (
    <Box
      sx={{
        p: "20px",
        height: "calc(100% - 40px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          fontSize={"1.4rem"}
          fontWeight={700}
          sx={{
            mt: "10px",
            userSelect: "none",
          }}
        >
          Authentis
        </Typography>
        <Box
          sx={{
            height: "5px",
            width: "48%",
            mb: "25px",
            background: COLORS.INDIAN_FLAG_GRAD,
          }}
        />
        <AvatarElement />
        <Typography
          fontSize={"0.8rem"}
          fontWeight={500}
          sx={{ opacity: "0.5", mt: "60px", ml: "10px" }}
        >
          TEAM
        </Typography>
        <Box
          sx={{
            mt: "1rem",
            display: "flex",
            flexDirection: "column",
            gap: "0.8rem",
          }}
        >
          {dashTabs.map(
            (item) => item.visible && <TabTile key={item.id} tabItem={item} />
          )}
        </Box>
      </Box>
      <Box>
        <LogoutDialog
          open={openLogoutDialog}
          onCloseFunc={() => {
            setopenLogoutDialog(false);
          }}
        />

        <Typography
          fontSize={"0.8rem"}
          fontWeight={500}
          sx={{ opacity: "0.5", mb: "10px", mt: "60px" }}
        >
          v1.1
        </Typography>
        <Typography
          fontSize={"0.8rem"}
          fontWeight={600}
          sx={{
            opacity: "0.5",
            mb: "20px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            cursor: "pointer",
            userSelect: "none",
          }}
          onClick={() => {
            setopenLogoutDialog(true);
          }}
        >
          <ExitToAppIcon
            sx={{
              mr: "5px",
            }}
          />{" "}
          LOG OUT
        </Typography>
        <Typography fontSize={"1rem"} fontWeight={500} sx={{ opacity: 1 }}>
          Made with ❤️ in India.
        </Typography>
      </Box>
    </Box>
  );
}

export default DashboardNav;
